/* src/app/main/pages/services/verticals/verticals.component.css */
/*# sourceMappingURL=verticals.component.css.map */
